app.component("myPatients", {
	templateUrl: "app/src/js/components/patientHeader/myPatients/myPatients.html",
	controller: "myPatientsController",
	bindings: {
		onPatientSelect: "&?",
	},
});

app.controller("myPatientsController", [
	"$scope",
	"$modal",
	"$timeout",
	"Session",
	"CurrentPatient",
	"PatientAPI",
	"$state",
	function ($scope, $modal, $timeout, Session, CurrentPatient, PatientAPI,$state) {
		$scope.CP = CurrentPatient;
		$scope.userIsPracticeAdmin = false;
		$scope.showWorkupButton = false;
		$scope.showOperationNoteButton = false;
		$scope.PA = PatientAPI;
		$scope.favoritePatientList = [];
		$scope.patientBackup = null;
		$scope.Session = Session;

		function syncFavoritePatientList() {
			$scope.favoritePatientList = (Session.user.features && Session.user.features.favoritePatientsFeature) || [];
		}

		syncFavoritePatientList();
		$scope.$on('favoritePatientsChanged', syncFavoritePatientList);
	
		$scope.selectPatient = function (patient) {
			if ($scope.CP.patientBackup) {
				$scope.patientBackup = angular.copy($scope.CP.patientBackup);
			}
			$scope.CP.clearPatient();

			$timeout(function () {
				$scope.CP.setPatient(patient);

				if (!$scope.CP.patientIsMine) {
					// Launch the new standalone transfer modal
					$modal({
						controller: "patientTransferController",
						templateUrl: "app/src/views/templates/modal.patient-transfer-flow.tpl.html",
						show: true,
						backdrop: "static",
						resolve: {
							patientId: function () {
								return patient.id;
							},
							onSuccess: function () {
								return function (updatedPatient) {
									$scope.CP.setPatient(updatedPatient);
									$state.go("patient-dashboard");
								};
							},
							onCancel: function () {
								return function () {
									// Restore the backup if they cancel
									if ($scope.patientBackup) {
										$scope.CP.setPatient($scope.patientBackup);
									} else {
										$scope.CP.clearPatient();
									}
								};
							}
						}
					});
				}
			});
		};

		$scope.switchPatient = function (patientId) {
			if ($scope.$ctrl.onPatientSelect) {
				$scope.$ctrl.onPatientSelect();
			}
			$state.go("patient-dashboard");
			if($scope.CP.patient && $scope.CP.patient.id === patientId){
				return;
			}
			$scope.PA.isProcessing = true;
			$scope.PA.getPatient(patientId).then(function (resp){
				$scope.selectPatient(resp.data);
			}, function (error) {
				$scope.serverErrorModal = $modal({
					scope: $scope,
					templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
					show: true,
					title: "CatTrax has encountered an error",
				});
			}).then(function (){
				$scope.PA.isProcessing = false;
			});
		}

		$scope.removeFavoritePatient = function (patientId) {
			$scope.PA.removeFavourite(patientId)
			.then(
				function (resp) {
					if ($scope.PA.isFavouriteResponseSuccess(resp.status)) {
						Session.user.features.favoritePatientsFeature =
							Session.user.features.favoritePatientsFeature.filter(t => t.patientId !== patientId);
						$scope.$root.$broadcast('favoritePatientsChanged');
					}
				},
				function (err) {
					console.error("Failed to remove favourite:", err && err.status);
				}
			)
			.then(function () {
				syncFavoritePatientList();
			});
		}
	},
]);
